import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import './styles.scss';

const StepGraphic = ({
    stepNumber, stepName, stepDescription, selectedStep, isFillCircle
}) => {
    const textColor = (selectedStep === stepNumber || isFillCircle) ? '#9DC3CC' : '#D06F6E';
    return (
        <div className='step-graphic-container' style={ { color: textColor } }>
            <span>{i18n.t('motivator.step')} {stepNumber}</span>
            <div className='circle' style={ { border: `4px solid ${ textColor }`, background: isFillCircle ? textColor : 'transparent' } } />
            <h3>{stepName}</h3>
            <Trans i18nKey={ stepDescription } parent='p' />
        </div>
    );
};

StepGraphic.propTypes = {
    stepNumber: PropTypes.number,
    stepName: PropTypes.string,
    stepDescription: PropTypes.string,
    selectedStep: PropTypes.number,
    isFillCircle: PropTypes.bool
};

StepGraphic.defaultProps = {
    stepNumber: 0,
    stepName: '',
    stepDescription: '',
    selectedStep: null,
    isFillCircle: false
};

export default StepGraphic;
